import { isFixtureMode } from "./memberService";
import { supabase } from "./supabase";
import type { TeamCellMember, TeamCellSummary } from "./workflowTypes";

async function fixtures() {
  if (!import.meta.env.DEV) throw new Error("Development fixtures are unavailable in production.");
  return import("./workflowFixtures");
}

export async function listMyTeamCells(): Promise<TeamCellSummary[]> {
  if (isFixtureMode) return (await fixtures()).fixtureTeamCells.filter((cell) => cell.id === "cell-closer-alpha");
  const { data, error } = await supabase!.from("member_team_cells").select("*").order("generated_usd", { ascending: false });
  if (error) throw error;
  return (data ?? []).map(mapCell);
}

export async function listAdminTeamCells(): Promise<TeamCellSummary[]> {
  if (isFixtureMode) return (await fixtures()).fixtureTeamCells;
  const { data, error } = await supabase!.from("admin_team_cells").select("*").order("generated_usd", { ascending: false });
  if (error) throw error;
  return (data ?? []).map(mapCell);
}

function mapCell(row: Record<string, unknown>): TeamCellSummary {
  return {
    id: String(row.id),
    name: String(row.name),
    route: String(row.route),
    managerHandle: String(row.manager_handle ?? "Unassigned"),
    minimumManagerLevel: Number(row.minimum_manager_level ?? 7),
    memberCount: Number(row.member_count ?? 0),
    activeTasks: Number(row.active_tasks ?? 0),
    overdueTasks: Number(row.overdue_tasks ?? 0),
    approvedTasks: Number(row.approved_tasks ?? 0),
    generatedUsd: Number(row.generated_usd ?? 0),
    managerOverrideUsd: Number(row.manager_override_usd ?? 0),
    inviteSlots: Number(row.invite_slots ?? 0),
    members: mapMembers(row.members),
  };
}

function mapMembers(value: unknown): TeamCellMember[] {
  if (!Array.isArray(value)) return [];
  return value.map((raw) => {
    const item = raw as Record<string, unknown>;
    return {
      id: String(item.id),
      handle: String(item.handle),
      route: String(item.route),
      level: Number(item.level ?? 0),
      trustScore: Number(item.trustScore ?? item.trust_score ?? 0),
      activeTasks: Number(item.activeTasks ?? item.active_tasks ?? 0),
      approvedTasks: Number(item.approvedTasks ?? item.approved_tasks ?? 0),
      generatedUsd: Number(item.generatedUsd ?? item.generated_usd ?? 0),
      overdueTasks: Number(item.overdueTasks ?? item.overdue_tasks ?? 0),
    };
  });
}
